<template>
  <v-container fluid class="billmaterial-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Bill of Material</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Materials</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="4">
                      <v-form>
                        <p class="text-h5">New Bill of Material</p>
                        <v-select
                          class="mb-4"
                          :items=billmaterialtype
                          v-model="billmaterial.billmaterialtype"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the bill type">
                        </v-select>
                        <v-menu
                          ref="new_billmaterialdate"
                          v-model="new_billmaterialdate"
                          :close-on-content-click="false"
                          :return-value.sync="billmaterial.billmaterialdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="billmaterial.billmaterialdate"
                              label="Bill Date"
                              v-bind="attrs"
                              v-bind:value="billmaterial.billmaterialdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the bill date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="billmaterial.billmaterialdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="new_billmaterialdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.new_billmaterialdate.save(billmaterial.billmaterialdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-select
                          class="mb-4"
                          :items="locations.map(x => {
                            return {text: x.locationname, value: x._id};
                            })"
                          v-model="billmaterial.locationid"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="items.map(x => {return {text: x.itemname, value: x._id}})"
                          v-model="billmaterial.itemid"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Item"
                          persistent-hint
                          single-line hint="Please choose the production item">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="billmaterial.itemquantity"
                          v-bind:error="errorindex == 5"
                          outlined
                          dense
                          placeholder="Quantity"
                          persistent-hint
                          single-line hint="Enter the production quantity">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items="['Ctn', 'Pak', 'Doz', 'Bot']"
                          v-model="billmaterial.itemunit"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Unit"
                          persistent-hint
                          single-line hint="Please choose the production unit">
                        </v-select>
                      </v-form>
                    </v-col>                               
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="7">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/billmaterial/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col lg="12" md="12" sm="12"><p class="text-h5">Items</p></v-col>
                    <v-col cols="12" sm="12" md="3" lg="3">
                      <v-select
                        class="mb-4"
                        :items="materials.map(x => {return {text: x.materialname, value: x._id}})"
                        v-model="add_transaction.materialid"
                        v-bind:error="errorindex == 11"
                        outlined
                        dense
                        placeholder="Material"
                        persistent-hint
                        single-line hint="Material">
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1">
                      <v-text-field
                        v-model="add_transaction.materialquantity"
                        class="mb-4"
                        outlined
                        dense
                        v-bind:error="errorindex == 12"
                        placeholder="Qty"
                        persistent-hint
                        type="number"
                        v-on:input="calculateAmount"
                        oninput="if(this.value < 1) this.value = 1;"
                        single-line hint="Quantity">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1">
                      <v-select
                        class="mb-4"
                        :items="['Eac', 'Kg', 'Pcs', 'Ton']"
                        v-model="add_transaction.materialunit"
                        v-bind:error="errorindex == 13"
                        outlined
                        dense
                        placeholder="Material"
                        persistent-hint
                        single-line hint="Material">
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1">
                      <v-text-field
                        v-on:input="calculateAmount"
                        v-model="add_transaction.materialprice"
                        class="mb-4"
                        outlined
                        dense
                        v-bind:error="errorindex == 14"
                        placeholder="Prc"
                        persistent-hint
                        type="number"
                        single-line hint="Price">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2">
                      <v-text-field
                        readonly
                        v-model="add_transaction.materialamount"
                        class="mb-4"
                        outlined
                        dense
                        v-bind:error="errorindex == 15"
                        placeholder="Amt"
                        persistent-hint
                        single-line hint="Amount">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1">
                      <v-btn
                        class="button-shadow"
                        color="success"
                        @click="addTransaction()">
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-data-table
                    :headers="materialHeaders"
                    :items="transactions"
                    :items-per-page="100"
                    class="elevation-0"
                  >
                    <template v-slot:item.materialimage="{ item }"> 
                      <v-img
                        v-bind:lazy-src="item.materialimage"
                        min-width=50
                        max-width=100
                        v-bind:src="item.materialimage"
                      ></v-img>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn icon color="primary" @click="loadTransaction(item)">
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                      <v-btn icon color="primary" @click="deleteTransaction(item)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                          outlined
                          color="primary"
                          @click="step = 1"
                        >
                          Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="insertBillMaterial()">
                          Save
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      materialHeaders: [
        { text: 'Image', value: 'materialimage' , width: '10%'},
        { text: 'Name', value: 'materialname' },
        { text: 'Qty', value: 'materialquantity', width: '10%'},
        { text: 'Prc', value: 'materialprice', width: '10%'},
        { text: 'Amount', value: 'materialamount', width: '15%'},
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      transactions: [],
      sheet: false,
      isSearchCustomer: false,
      brandid: undefined,
      price: undefined,
      cid: undefined,
      
      
      add_transaction: {},

      step: 1,
      billmaterial: {
        billmaterialsubtotal: 0,
        billmaterialdeliverycost: 0,
        billmaterialtotal: 0,
      },
      new_billmaterialdate: false,
      billmaterialtype: ['Production Materials', 'Assembly Materials'],
      error: undefined,
      errortag: false,
      errorindex: undefined,
    }
  },
  computed: {
    ...mapState('BillMaterial', ['isReceiving']),
    ...mapState('Brand', ['brands']),
    ...mapState('Item', ['items']),
    ...mapState('Location', ['locations']),
    ...mapState('Material', ['materials'])
  },
  methods: {
    ...mapActions('BillMaterial', ['getBillMaterials', 'insertBillMaterialRequest']),
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('Material', ['getMaterialsRequest']),
    checkError(){
      if(this.billmaterial!=null) {
        this.errorindex = -1;
        this.step = 2;
        return true;
      }
      if(!this.billmaterial.billmaterialtype){
        this.errortags = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.billmaterial.billmaterialdate){
        this.errortags = true;
        this.errorindex = 1;
        return false;
      }
      if(this.billmaterial.billmaterialtype=='Sales BillMaterial' && !this.billmaterial.pricelistid){
        this.errortags = true;
        this.errorindex = 2;
        return false;
      }
      else if(this.billmaterial.billmaterialtype=='Service BillMaterial'){
        this.billmaterial.pricelistid = null;
      }
      if(!this.billmaterial.customerid){
        this.errortags = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.billmaterial.billmaterialaddress){
        this.errortags = true;
        this.errorindex = 4;
        return false;
      }
      if(!this.billmaterial.billmaterialphone){
        this.errortags = true;
        this.errorindex = 5;
        return false;
      }
      if(!this.billmaterial.locationid){
        this.errortags = true;
        this.errorindex = 6;
        return false;
      }
      if(!this.billmaterial.countryid){
        this.errortags = true;
        this.errorindex = 7;
        return false;
      }
      if(!this.billmaterial.billmaterialpayterms){
        this.errortags = true;
        this.errorindex = 10;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkError2(){
      if(!this.add_transaction.materialid){
        this.errortags = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.add_transaction.materialquantity){
        this.errortags = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.add_transaction.materialquantity){
        this.errortags = true;
        this.errorindex = 14;
        return false;
      }
      if(!this.add_transaction.materialamount){
        this.errortags = true;
        this.errorindex = 15;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    checkError3(){
      if(!this.accountid){
        this.errortags = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.itemdesc){
        this.errortags = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.itemamount){
        this.errortags = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    addTransaction(){
      if(!this.checkError2()) return;
      let material = this.materials.find(material=>material._id == this.add_transaction.materialid);
      let json = {materialimage: material.materialimage, materialname: material.materialname};
      this.add_transaction = Object.assign({}, this.add_transaction, json);
      this.transactions.push(this.add_transaction);

      //this.calculateTotal();
      //this.clearFields();
    },
    calculateAmount(){
      let amount = this.add_transaction.materialquantity * this.add_transaction.materialprice;
      this.add_transaction = Object.assign({}, this.add_transaction, {materialamount: amount});
    },
    calculateTotal(){
      this.billmaterial.billmaterialsubtotal = this.transactions.reduce((a, b) => a + (b.itemamount), 0);
      this.billmaterial.billmaterialtotal = this.billmaterial.billmaterialsubtotal;
    },
    clearFields(){
      this.cid = undefined;
      this.itemid = undefined;
      this.itemimage = undefined;
      this.itemname = undefined;
      this.itemquantity = 1;
      this.itemprice = undefined;    
      this.itemamount = undefined;
      this.itemcategoryid = undefined
      this.itemsubcategoryid = undefined;
    },
    clearTransactions(){
      this.transactions = [];
      this.billmaterial.billmaterialsubtotal = 0;
      this.billmaterial.billmaterialtotal = 0;
    },
    async insertBillMaterial() {
      let payload = {billmaterial: this.billmaterial, transactions: this.transactions};
      await this.insertBillMaterialRequest(payload);
      router.push('/billmaterial/list');
    },
    deleteTransaction(item){
      let index;
      index = this.findTransactionIndexByTransId(item.id);
      if(index!=-1) this.transactions.splice(index,1);
      if(this.billmaterial.billmaterialtype=='Sales BillMaterial'){
        index = this.findTransactionIndexByRefId(item.itemid);
        if(index!=-1) this.transactions.splice(index,1);
      }
      this.calculateTotal();
    },
    findTransactionIndexByTransId(id){
      let index;
      if(this.transactions.find(tran=>tran.id==id)==null) {return -1}
      for(index=0; index<this.transactions.length; index++){
        if(this.transactions[index].id==id){break;}
      }
      return index;
    },
    findTransactionIndexByRefId(id){
      let index;
      if(this.transactions.find(tran=>tran.refid==id)==null) {return -1}
      for(index=0; index<this.transactions.length; index++){
        if(this.transactions[index].refid==id){break;}
      }
      return index;
    },
    findTransactionIndexByItemid(itemid){
      let index;
      if(this.transactions.find(tran=>tran.itemid==itemid)==null) {return -1}
      for(index=0; index<this.transactions.length; index++){
        if(this.transactions[index].itemid==itemid){break;}
      }
      return index;
    },
    findPriceByQuantity(itemid, qty){
      let item = this.items.find(item=>item._id==itemid);
      let price = item.prices.find(price=> parseInt(qty)>=price.minqty && parseInt(qty)<=price.maxqty);
      return price;
    },
    

    populateItems(brandid){
      let items = this.items.filter(item=>item.brandid == brandid);
      this.branditems = items.map(x => {return {text: x.itemname, value: x._id};})
    },
    updateTransaction(index){
      let trans = this.transactions[index];
      trans.itemquantity =  parseInt(this.itemquantity);
      trans.itemamount = trans.itemquantity * trans.itemprice;
      this.updateFOCTransaction();
    },
    loadTransaction(item){
      this.cid = item.id;
      this.sheet = !this.sheet;
      this.brandid = item.brandid;
      this.itemid = item.itemid;
      this.itemimage = item.itemimage;
      this.itemname = item.itemname;
      this.itemquantity = item.itemquantity;
      if(this.itemfoc=='Foc')this.itemprice = 0;
      else this.itemprice = item.itemprice;
  
      this.itemamount = item.itemamount;
      this.itemcategoryid = item.itemcategoryid;
      this.itemsubcategoryid = item.itemsubcategoryid;
    },
    editTransaction(){
      var trans = this.transactions.find(tran=>tran.id==this.cid);
      trans.brandid = this.brandid;
      trans.itemid = this.itemid;
      trans.itemimage = this.itemimage;
      trans.itemname = this.itemname;
      trans.itemquantity = this.itemquantity;
      if(trans.itemfoc=='Foc') trans.itemprice = 0
      else trans.itemprice = this.itemprice;
      trans.itemamount = this.itemamount;
      trans.itemcategoryid = this.itemcategoryid;
      trans.itemsubcategoryid = this.itemsubcategoryid;
      this.sheet = !this.sheet;
      this.calculateTotal();
      this.clearFields();
    },
  },

  async created () {
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.items.length==0) await this.getItemsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.materials.length==0) await this.getMaterialsRequest();  
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
